export const applyRemoveUUID = (uuid) => {
  const toReplace = new RegExp(
    "[a-fA-F0-9(]{9}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[)a-fA-F0-9]{13}"
  );
  const replacedUUID = uuid.replace(toReplace, "");

  return replacedUUID;
};
